import * as React from "react"
import {useTranslation, I18nextContext} from 'gatsby-plugin-react-i18next';
import { SubscribeForm } from "../subscribe-form/subscribe-form";
import imageCodeWe from "../../images/modal/code-we.jpg";

import './text.scss';
// Defining the <Greeting> component
export const Text = (props) => {
  const { t } = useTranslation();
  let text = t((props.page), { returnObjects: true });
  let pars =  text && text[0].paragraphs;
  const context = React.useContext(I18nextContext);
  let lang = context.language;
  let isChina = lang === 'zh_hans' || lang === 'zh_hant' ? true : false;

  return (
    <div className="text">
      <div className="text__text">
        {text && 
        <>
          <h2 className="text__title">
            {text[0].title}
          </h2>
          {
            text[0].subtitle &&
            <h3 className="text__subtitle">
              {text[0].subtitle}
            </h3>

          }
          
          </>
        }
        
        
        {
          pars && pars.map((par, i) => {
            return (
              <p key={`paragraph${i}`}className="text__par">
                 {par.paragraph} 
              </p>
              
              )
          })
        }
        {
          props.hasNewsletter &&
            <>
              {
                isChina ? 
                (
                  <div>
                    <div className="subscribeFrom__alternative">
                      <span className="subscribeForm__alternativeText">{t('title modal we')}</span>
                      <div>
                      <span className="modalOverlay__overlayIcon"></span>
                      <img src={imageCodeWe} className="modalOverlay__overlayImageCode"/>
                    </div>
                    </div>
                  </div>
                ): (
                  <>
                    <h2 className="text__title">
                      {t('titleNLSubscription')}
                    </h2>
                    <p className="text__par">
                      {t('subtitleNLSubscription')}
                    </p>
                    <SubscribeForm hasText = {true}></SubscribeForm>
                    </>
                )

              }
              
            </>
        }
        
      </div>
    </div>
        
    )
  }